var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircleGold = function SvgCheckCircleGold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AD8943",
    d: "M.945 7.843c0-3.856 3.117-7 7-7 3.855 0 7 3.144 7 7 0 3.882-3.145 7-7 7-3.883 0-7-3.118-7-7m10.144-1.204c.3-.3.3-.765 0-1.066-.3-.3-.766-.3-1.066 0L7.07 8.526 5.84 7.323c-.302-.3-.767-.3-1.067 0-.301.3-.301.766 0 1.066l1.75 1.75c.3.301.765.301 1.066 0z"
  })));
};
export default SvgCheckCircleGold;